import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { SWRConfig } from 'swr';
import '#admin/axios';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthWatcher } from '#admin/component/AuthWatcher.tsx';
import { DialogProvider } from '#admin/component/DialogProvider.tsx';
import { Router } from '#admin/Router.tsx';
import { store } from '#admin/store.ts';
import '#admin/i18n.ts';
import '#admin/onesignal.ts';

const App = () => (
  <Provider store={store}>
    <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
      <SWRConfig value={{ revalidateOnFocus: false, shouldRetryOnError: false, dedupingInterval: 1000 }}>
        <DialogProvider>
          <AuthWatcher />
          <Router />
        </DialogProvider>
      </SWRConfig>
    </GoogleOAuthProvider>
  </Provider>
);

const root = createRoot(document.getElementById('root') as Element);
root.render(<App />);
